import {
  getSelectedTheme,
  setSelectedTheme,
  subscribeToTheme,
  toggleTheme,
  useResolvedTheme
} from '@Core/hooks/useTheme';
import { useSyncExternalStore } from 'react';

export type SdkThemeMode = 'light' | 'dark' | 'system';

export type UseThemeResult = {
  theme: 'light' | 'dark';
  mode: SdkThemeMode;
  setTheme: (mode: SdkThemeMode) => void;
  toggleTheme: () => void;
};

function getMode(): SdkThemeMode {
  const selected = getSelectedTheme();

  return selected === 'dark' || selected === 'light' ? selected : 'system';
}

function setTheme(mode: SdkThemeMode): void {
  setSelectedTheme(mode === 'dark' || mode === 'light' ? mode : null);
}

export function useTheme(): UseThemeResult {
  const theme = useResolvedTheme();
  const mode = useSyncExternalStore(subscribeToTheme, getMode, getMode);

  return { theme, mode, setTheme, toggleTheme };
}
